export default __webpack_public_path__ + "static/media/gluten.b25fad74.svg";